<div class="kds-wrapper">

  <!-- Top bar -->
  <div class="kds-topbar">
    <div class="kds-clock">
      <div class="kds-clock-time">{{ currentTime | date:'HH:mm' }}</div>
      <div class="kds-clock-date">{{ currentTime | date:'EEEE · d MMM' }}</div>
    </div>
    <p-selectbutton [options]="viewOptions" [(ngModel)]="showCompleted" optionLabel="label" optionValue="value"></p-selectbutton>
    <div class="kds-topbar-right">
      <div class="kds-refresh" (click)="loadSales()" title="Refresh">
        <i class="pi pi-refresh"></i>
      </div>
      <button class="kds-back-btn" (click)="exitKDS()">
        <i class="pi pi-arrow-left"></i> Back to System
      </button>
    </div>
  </div>

  <!-- Card template -->
  <ng-template #orderCard let-order>
    <div
      class="kds-card"
      [ngClass]="[showCompleted ? 'card-completed' : getCardUrgencyClass(order.createddate), (!showCompleted && isPriority(order)) ? 'card-priority' : '']">

      <!-- Card header -->
      <div class="kds-card-header">
        @if (order.tablenumber) {
          <div class="kds-table-number">Table {{ order.tablenumber }}</div>
        }
        <div class="kds-card-header-row">
          <div class="kds-card-header-left">
            <span class="kds-order-name">{{ getOrderDisplayName(order) }}</span>
            <span class="kds-order-elapsed">Time Since Order: {{ getElapsedLabel(order.createddate) }}</span>
          </div>
          <div class="kds-card-header-right">
            @if (showCompleted) {
              <span class="kds-completed-badge">
                <i class="pi pi-check-circle"></i> Done
              </span>
            }
          </div>
        </div>
      </div>

      <!-- Items -->
      <div class="kds-items">
        @for (item of kitchenItemsFor(order); track item) {
          <div class="kds-item">
            <div class="kds-item-row">
              <span class="kds-item-qty">{{ item.qty ?? 1 }}</span>
              <span class="kds-item-name">{{ getItemName(item) }}</span>
            </div>
            @if (getItemOptions(item).length > 0) {
              <div class="kds-item-options">
                @for (opt of getItemOptions(item); track opt) {
                  <div class="kds-option">
                    {{ opt.name }}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <!-- Notes display -->
      @if (order.notes) {
        <div class="kds-notes">
          <i class="pi pi-comment" style="margin-right:6px; opacity:0.6;"></i>{{ order.notes }}
        </div>
      }

      <!-- Card footer -->
      <div class="kds-card-footer">
        @if (!showCompleted) {
          <div style="display:flex; gap:6px;">
            <button
              class="kds-priority-btn"
              [class.kds-priority-btn--active]="isPriority(order)"
              (click)="markPriority(order)">
              <i class="pi pi-bolt"></i> Priority
            </button>
            <button
              class="kds-complete-btn"
              (click)="markComplete(order)">
              <i class="pi pi-check"></i> Complete
            </button>
          </div>
        }
        @if (showCompleted) {
          <button
            class="kds-reopen-btn"
            (click)="markReopen(order)">
            <i class="pi pi-undo"></i> Reopen
          </button>
        }
      </div>

      <!-- Amended banner -->
      @if (isAmended(order)) {
        <div class="kds-amended-bar">
          <i class="pi pi-pencil"></i> Amended: {{ order.lastupdated | date:'HH:mm' }}
        </div>
      }

      <!-- Till name bar -->
      @if (order.tillname) {
        <div class="kds-till-bar">
          <i class="pi pi-desktop"></i> {{ order.tillname }}
        </div>
      }

    </div>
  </ng-template>

  <!-- Order cards -->
  <div class="kds-cards-scroll">
    @if (displayedOrders.length === 0) {
      <div class="kds-no-orders">
        <span>{{ showCompleted ? 'No completed orders' : 'No open orders' }}</span>
      </div>
    }

    @for (group of groupedDisplayedOrders; track group) {
      <!-- Grouped: multiple orders sharing same table number -->
      @if (group.isGroup) {
        <div class="kds-group">
          @for (order of group.orders; track order) {
            <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: order }"></ng-container>
          }
        </div>
      }
      <!-- Single order -->
      @if (!group.isGroup) {
        <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: group.orders[0] }"></ng-container>
      }
    }
  </div>

</div>

<p-dialog header="Order Notes" [(visible)]="showNotesDialog" [modal]="true" [style]="{width:'420px'}" [draggable]="false" [resizable]="false">
  <textarea
    pTextarea
    [(ngModel)]="notesText"
    [autoResize]="true"
    rows="5"
    placeholder="Add notes for this order..."
    style="width:100%; font-size:15px;">
  </textarea>
  <ng-template #footer>
    <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="saveNotes()">
      <span class="pi pi-check" style="margin-right:6px;"></span>Save
    </button>
    <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="margin-left:8px;" (click)="showNotesDialog=false">
      <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
    </button>
  </ng-template>
</p-dialog>
